export enum LocalStorageRegistry {
  PAYMENT_ESTIMATOR_FORM = 'PaymentEstimatorForm',
  realEstate = 'hasDismissedRealEstateMapSrpCTA',
  RECENT_LOCATIONS = 'RecentSearchLocations',
  registration = 'hasDismissedRegistrationCTA',
  LOCAL_USER_PREFERENCES = 'localUserPreferences',
  R2S_GUEST_CONTACT = 'r2sGuestContact',
}
